import axios from '@/libs/http'
import {appendIfNotEmpty} from "@/libs/util";


/**
 *  获取店员列表(更换店员)
 *  */
export const getClerkList = (keyword, pageNo, pageSize) => {
    let data = new URLSearchParams()
    appendIfNotEmpty(data,'keyword', keyword)
    data.append("pageNo", pageNo)
    data.append("pageSize", pageSize)
    return axios.request({
        url: '/s/k/outOrder/getClerkList',
        data,
        method: 'post'
    })
}

/**
 * 获取订单列表
 * */
export const getOrderList = ( no, keyword,status,pageNo, pageSize) => {
    let data = new URLSearchParams()
    appendIfNotEmpty(data,'no', no)
    appendIfNotEmpty(data,'keyword', keyword)
    appendIfNotEmpty(data,'status', status)
    data.append("pageNo", pageNo)
    data.append("pageSize", pageSize)
    return axios.request({
        url: '/s/k/outOrder/list',
        data,
        method: 'post'
    })
}
/**
 * 获取订单详情
 */
export const getOutOrder = (id) => {
    return axios.request({
        url: '/s/k/outOrder/get',
        params: {
            id
        },
        method: 'get'
    })
}

/**
 * 获取订单详情
 */
export const deleteOutOrder = (id) => {
    return axios.request({
        url: '/s/k/outOrder/delete',
        params: {
            id
        },
        method: 'get'
    })
}

/**
 * 创建外部订单
 * */
export const createOutOrder = (
    no,
    clerkId,
    userId,
    itemContent,
    totalAmount,
    clerkWagesRatio,
    clerkWagesAmount,
    startTime,
    endTime,
    continueRemark,
    remark,
    photoUrls
) => {
    const data = new URLSearchParams();
    if (no) {
        data.append("no", no);
    }
    data.append("clerkId", clerkId);
    if (userId){
        data.append("userId", userId);
    }
    data.append("itemContent", itemContent);
    data.append("totalAmount", totalAmount);
    data.append("clerkWagesRatio", clerkWagesRatio);
    data.append("clerkWagesAmount", clerkWagesAmount);
    data.append("startTime", startTime);
    if(endTime){
        data.append("endTime", endTime);
    }
    if (continueRemark) {
        data.append("continueRemark", continueRemark);
    }
    if (remark) {
        data.append("remark", remark);
    }
    if (photoUrls) {
        data.append("photoUrls", photoUrls);
    }

    return axios.request({
        url: '/s/k/outOrder/add',
        data,
        method: 'post'
    })
}

/**
 * 修改外部订单
 * */
export const updateOutOrder = (
    id,
    clerkId,
    itemContent,
    totalAmount,
    clerkWagesRatio,
    clerkWagesAmount,
    startTime,
    endTime,
    continueRemark,
    remark,
    photoUrls
) => {
    const data = new URLSearchParams();
    data.append("id", id);
    data.append("clerkId", clerkId);
    data.append("itemContent", itemContent);
    data.append("totalAmount", totalAmount);
    data.append("clerkWagesRatio", clerkWagesRatio);
    data.append("clerkWagesAmount", clerkWagesAmount);
    data.append("startTime", startTime);
    if(endTime){
        data.append("endTime", endTime);
    }
    if (continueRemark) {
        data.append("continueRemark", continueRemark);
    }
    if (remark) {
        data.append("remark", remark);
    }
    data.append("photoUrls", photoUrls);
    return axios.request({
        url: '/s/k/outOrder/update',
        data,
        method: 'post'
    })
}
